{
    "Messages_Type_Label": "Berichttype",
    "Messages_Language_Label": "Taal",
    "Messages_Language_DefaultOption": "Standaard \/ Terugvaloptie",
    "Messages_Subject_Label": "Onderwerp",
    "Messages_PlainBody_Label": "Tekst (platte tekst)",
    "Messages_HtmlBody_Label": "Tekst (HTML)",
    "Messages_NewLocale_Info": "Er wordt een nieuw berichtitem voor deze taal aangemaakt wanneer u opslaat.",
    "Messages_Action_Save": "Redden",
    "Messages_Action_Revert": "Terugdraaien",
    "Messages_Action_Delete": "Verwijderen",
    "Messages_DiscardChanges_Prompt": "Niet-opgeslagen wijzigingen verwijderen?",
    "Messages_DiscardChanges_Confirm": "Wijzigingen negeren",
    "Messages_DiscardChanges_Cancel": "Blijf bewerken",
    "Messages_Save_Success": "Bericht opgeslagen.",
    "Messages_Save_Error": "Het bericht kon niet worden opgeslagen.",
    "Messages_Delete_Success": "Bericht verwijderd.",
    "Messages_Delete_Error": "Het bericht kan niet worden verwijderd.",
    "NAME": "BerichtenTaal"
}